import React, { Component } from 'react';
import { connect } from 'react-redux';
import card from '../../images/icons/ico_cc_def.png';
import cardVisa from '../../images/icons/ico_cc_visa.png';
import { withTranslation } from 'react-i18next'
import { PAYMENT_GATEWAY, CARD_CAN_BE_CHARGED, DEMO, CARD_DEMO, CMSPath } from '../../../config/constant';
import Loader from '../../UI/loader';
import clientConfigApi from '../../../config/config';
import { setCardStatusPopupProps, setCheckinCurrentPageName } from '../../action/autoCheckin';
import { popupOpenClose, setCheckInAddress } from "../../../action/action";
import { sendAnalytics } from "../../../action/homeAction"
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import $ from "jquery";
import { th } from 'date-fns/locale';
import Select from 'react-select';
import { scrollToTop } from '../../../JS/scrollToTop';

class FreedomPay extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showLoader: false,
            IFrameLoading: true,
            disableVerifyButton: false,
            sessionToken: localStorage.getItem("GuestJourneySessionToken"),
            sessionKeyFreedomPay: null,
            shouldShowIFrame: false,
            verifyAttempts: 0,
            firstName: "",
            lastName: "",
            fullName: "",
            firstNameError: "",
            lastNameError: "",
            phoneNumber: "",
            email: "",
            address: {
                addressLine1: "",
                country: "",
                city: "",
                state: "",
                postalCode: ""
            }
        }

        this.freedomPayDisplayConfigs = {
            "Button": { "Integrated": false },
            "CardNumber": {
                "LabelType": "Required",
                "MaskType": 3,
                "PlaceholderType": "EnterCardNumber"
            },
            "ExpirationDate": {
                "LabelType": 1,
                "PlaceholderType": 2
            },
            "SecurityCode": {
                "LabelType": 1,
                "MaskType": 3,
                "PlaceholderType": 2
            }
            ,
            "PaymentType": 1
        }

        this.iframeRef = React.createRef();
        this.handleMessageEvent = this.handleMessageEvent.bind(this);
        // this.confirmCardWithFreedomPay = this.confirmCardWithFreedomPay.bind(this);
        this.freedomPayCallback = this.freedomPayCallback.bind(this);
        window.addEventListener("message", this.handleMessageEvent);
    }

    freedomPayCallback = (response) => {

        const maxRetries = this.props.guestValidationMaxRetry || 3;

        if (this.state.verifyAttempts >= maxRetries) {
            this.props.showFailScreen(true, "Maximum Card verification attempts reached.", true);
            return;
        }

        this.setState(prevState => ({
            verifyAttempts: prevState.verifyAttempts + 1
        }));

        console.log("callback response: ", response)

        if (response.status == "SUCCESS") {
            // this.registerClientIP();
            console.log("Got success from Iframe")

            this.setState({ showLoader: true })

            let cardDigits = response.data.data.attributes.find(ob => ob.Key == "MaskedCardNumber").Value.slice(-4)

            clientConfigApi.post("/mobileCheckIn/cardValidation", {
                "header": {
                    "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                    "actionKey": "checks"
                },
                "payload": {
                    "confirmationNumber": this.props.confirmationNumber,
                    "lastNameCard": this.state.lastName,
                    "cardDigits": cardDigits,
                    "cardCheckId": response.data.data.paymentKeys[0],
                    "cardFullName": this.state.firstName + " " + this.state.lastName
                }
            })
                .then((resp) => {
                    if (resp.status == 200) {
                        console.log("checks call got success")
                        clientConfigApi.post("/mobileCheckIn/cardValidation", {
                            "header": {
                                "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                                "actionKey": "cardUpdate"
                            },
                            "payload": {
                                "confirmationNumber": this.props.confirmationNumber,
                                "cardDigits": cardDigits,
                                "sessionKey": this.state.sessionKeyFreedomPay,
                                "firstNameCard": this.state.firstName,
                                "lastNameCard": this.state.lastName,
                                "phoneNumber": this.state.phoneNumber,
                                "email": this.state.email,
                                "vaultedCardId": response.data.data.paymentKeys[0],
                                "cardTypeCode": response.data.data.attributes.find(ob => ob.Key == "CardIssuer").Value,
                                "expiryDate": response.data.data.attributes.find(ob => ob.Key == "ExpirationDate").Value.replace("/", ""),
                                "address": this.state.address
                            }
                        })
                            .then((res) => {
                                console.log("cardUpdate call got success", res)

                                if (res.status == 200) {
                                    this.props.setCardStatusPopupProps({
                                        cardStatus: true,
                                        statusTitle: 'Success',
                                        statusMessage1: 'Card verified successfully',
                                        statusMessage2: 'Please proceed to next steps'
                                    })
                                    this.props.showCardVerified({ firstName: this.state.firstName, lastName: this.state.lastName, address: this.state.address, phone: this.state.phoneNumber, email: this.state.email })
                                    this.props.setcardVerified();
                                    localStorage.setItem("cardVerfied", true)
                                    this.setState({ IFrameLoading: false })


                                    // Send Analytics
                                    let label = {
                                        "dateTime": new Date,
                                        "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                                        "Room": localStorage.getItem("room") || "",
                                        "sourceApp": "guestJourneyApp",
                                        "layoutTab": this.props.currentHomePage.tabName,
                                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                    }
                                    this.props.sendAnalytics(
                                        null,
                                        this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                                        "CREDIT CARD DETAILS - SUCCESS",
                                        label,
                                        0,
                                        false
                                    );
                                } else {
                                    this.props.showFailScreen(true, resp.data && resp.data.header && resp.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");
                                    let failedReason = resp.data && resp.data.header && resp.data.header.status.msg || "Card verification failed"
                                    let label = {
                                        "dateTime": new Date,
                                        "errorMessage": failedReason,
                                        "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                                        "Room": localStorage.getItem("room") || "",
                                        "sourceApp": "guestJourneyApp",
                                        "layoutTab": this.props.currentHomePage.tabName,
                                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                    }
                                    this.props.sendAnalytics(
                                        null,
                                        this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                                        "CREDIT CARD DETAILS - FAILED",
                                        label,
                                        0,
                                        false
                                    );

                                }

                                this.setState({ showLoader: false })

                            })
                            .catch((err) => {

                                if (err.response && err.response.data && err.response.data.header && err.response.data.header.status.errorType === "3DS_REQUIRED") {
                                    this.iframeRef.current.contentWindow.postMessage('SOFT_DECLINE', '*');
                                    return;
                                }

                                this.setState({ showLoader: false })

                                this.props.showFailScreen(true, err.response && err.response.data && err.response.data.header && err.response.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");

                                // Send Analytics
                                let failedReason = err.response && err.response.data && err.response.data.header && err.response.data.header.status.msg || "Card verification failed"
                                let label = {
                                    "dateTime": new Date,
                                    "errorMessage": failedReason,
                                    "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                                    "Room": localStorage.getItem("room") || "",
                                    "sourceApp": "guestJourneyApp",
                                    "layoutTab": this.props.currentHomePage.tabName,
                                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                }
                                this.props.sendAnalytics(
                                    null,
                                    this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                                    "CREDIT CARD DETAILS - FAILED",
                                    label,
                                    0,
                                    false
                                );
                            })
                    } else {

                        this.setState({ showLoader: false })

                        this.props.showFailScreen(true, resp.data && resp.data.header && resp.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");
                        let failedReason = resp.data && resp.data.header && resp.data.header.status.msg || "Card verification failed"
                        let label = {
                            "dateTime": new Date,
                            "errorMessage": failedReason,
                            "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                            "Room": localStorage.getItem("room") || "",
                            "sourceApp": "guestJourneyApp",
                            "layoutTab": this.props.currentHomePage.tabName,
                            "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                        }
                        this.props.sendAnalytics(
                            null,
                            this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                            "CREDIT CARD DETAILS - FAILED",
                            label,
                            0,
                            false
                        );
                    }
                })
                .catch((err) => {

                    this.setState({ showLoader: false })

                    this.props.showFailScreen(true, err.response.data && err.response.data.header && err.response.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");

                    // Send Analytics
                    let failedReason = err.response.data && err.response.data.header && err.response.data.header.status.msg || "Card verification failed"
                    let label = {
                        "dateTime": new Date,
                        "errorMessage": failedReason,
                        "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                        "Room": localStorage.getItem("room") || "",
                        "sourceApp": "guestJourneyApp",
                        "layoutTab": this.props.currentHomePage.tabName,
                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                    }
                    this.props.sendAnalytics(
                        null,
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                        "CREDIT CARD DETAILS - FAILED",
                        label,
                        0,
                        false
                    );
                })
        }
        else if (response.status == "FAILURE") {
            console.log("Got Failure from Iframe")
            const isUnauthorized = response.data && response.data.error[0] && response.data.error[0].messageCode === "resourceUnauthorized" ? true : false;
            this.props.showFailScreen(true, response.data && response.data.error[0] && response.data.error[0].messageCode || "Something went wrong", isUnauthorized);
        }
    };

    handleMessageEvent(e) {
        try {
            console.log("Recieved message from iframe")
            if (e.data && JSON.parse(e.data) && JSON.parse(e.data).status) {

                this.freedomPayCallback(JSON.parse(e.data));
            }
        } catch (error) {
            this.setState({ showLoader: false })

            console.log("error handling message eventlistener", error)
        }
    }


    // confirmCardWithFreedomPay() {
    //     if (this.iframeRef.current) {
    //         this.iframeRef.current.contentWindow.postMessage('verifyButtonClicked', '*');
    //     } else {
    //         this.props.showFailScreen(true, "Something went wrong");
    //     }
    // }

    registerClientIP = () => {
        this.setState({ showLoader: true, IFrameLoading: true });

        clientConfigApi.post("/mobileCheckIn/cardValidation", {
            "header": {
                "sessionToken": this.state.sessionToken,
                "actionKey": "register"
            },
            "payload": {
                "confirmationNumber": this.props.confirmationNumber,
                "freedomPayDisplayConfigs": this.freedomPayDisplayConfigs,
                "firstNameCard": this.state.firstName,
                "lastNameCard": this.state.lastName,
                "phoneNumber": this.state.phoneNumber,
                "email": this.state.email,
                "address": this.state.address
            }
        }).then(response => {
            if (response.status == 200) {

                this.setState({
                    showLoader: false,
                    sessionKeyFreedomPay: response.data.payload.tokenStr,
                    shouldShowIFrame: true
                })
            }
            else {
                this.setState({ showLoader: false });
                this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");

                let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
                let label = {
                    ...getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" }),
                    "dateTime": new Date,
                    "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                }

                this.props.sendAnalytics(
                    null,
                    this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "CREDIT CARD DETAILS - FAILED",
                    label,
                    0,
                    false
                );

            }

        }).catch(response => {
            this.setState({ showLoader: false })
            this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");
            this.props.backBtn();
            let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
            let label = {
                ...getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" }),
                "dateTime": new Date,
                "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
            }
            this.props.sendAnalytics(
                null,
                this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                "CREDIT CARD DETAILS - FAILED",
                label,
                0,
                false
            );
        })
    }

    confirmCardWithPMS = () => {

        if (!this.state.firstName) {
            this.props.popupOpenClose(true, "Please enter your first name");
            return;
        }

        if (!this.state.lastName) {
            this.props.popupOpenClose(true, "Please enter your last name");
            return;
        }

        if (!this.state.phoneNumber) {
            this.props.popupOpenClose(true, "Please enter your phone number");
            return;
        }

        if (!this.state.email) {
            this.props.popupOpenClose(true, "Please enter your email");
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(this.state.email)) {
            this.props.popupOpenClose(true, "Please enter a valid email address");
            return;
        }

        if (!this.state.address.country || this.state.address.country == "") {
            this.props.popupOpenClose(true, "Please enter your country");
            return;
        }

        if (!this.state.address.addressLine1 || this.state.address.addressLine1 == "") {
            this.props.popupOpenClose(true, "Please enter your address");
            return;
        }

        if (!this.state.address.city || this.state.address.city == "") {
            this.props.popupOpenClose(true, "Please enter your city");
            return;
        }

        // if (!this.state.address.state || this.state.address.state == "") {
        //     this.props.popupOpenClose(true, "Please enter your state");
        //     return;
        // }

        if (!this.state.address.postalCode || this.state.address.postalCode == "") {
            this.props.popupOpenClose(true, "Please enter your postal code");
            return;
        }

        if (!(/^[a-zA-Z0-9, .]+$/.test(this.state.address.addressLine1))) {
            this.props.popupOpenClose(true, "Please note that only English letters and numbers are accepted for the address")
            return;
        }

        this.props.setCheckInAddress({ ...this.props.checkInAddress, ...this.state.address })

        if (CARD_DEMO) {
            this.props.showLoader(true);
            setTimeout(() => {
                this.props.showLoader(false);
                this.setState({ cardVerified: true })
                this.props.setCardStatusPopupProps({
                    cardStatus: true,
                    statusTitle: 'Success',
                    statusMessage1: 'Card verified successfully',
                    statusMessage2: 'Please proceed to next steps'
                })
                this.props.showCardVerified({ firstName: this.state.firstName, lastName: this.state.lastName, address: this.state.address, phone: this.state.phoneNumber, email: this.state.email })
                localStorage.setItem('cardVerfied', true)

                let label = {
                    "dateTime": new Date,
                    "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                    "Room": localStorage.getItem("room") || "",
                    "sourceApp": "guestJourneyApp",
                    "layoutTab": this.props.currentHomePage.tabName,
                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                }
                this.props.sendAnalytics(
                    null,
                    this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "CREDIT CARD DETAILS - SUCCESS",
                    label,
                    0,
                    false
                );

            }, 1500)
            return;
        }

        // this.props.showLoader(true);
        this.setState({ showLoader: true })
        this.registerClientIP();
    }

    handleInputChange = (e, field) => {
        if (field === "country") {
            this.setState({
                address: { ...this.state.address, country: e.value }
            });
            return;
        }

        const { name, value } = e.target;

        if (name === "firstName") {
            if (/\d/.test(value)) {
                this.setState({ firstNameError: "First name cannot contain digits" });
                return; // don't update state with value
            }

            this.setState({
                firstName: value,
                firstNameError: ""
            });
            return;
        }

        if (name === "lastName") {
            if (/\d/.test(value)) {
                this.setState({ lastNameError: "Last name cannot contain digits" });
                return;
            }

            this.setState({
                lastName: value,
                lastNameError: ""
            });
            return;
        }

        if (this.state.address.hasOwnProperty(name)) {
            this.setState({
                address: { ...this.state.address, [name]: value }
            });
            return;
        }

        this.setState({ [name]: value });
    };


    getAddressLabel = () => {

        let labelName = null;

        this.props.countryOptions.forEach(item => {
            if (item.countryId == this.state.address.country) {
                labelName = item.countryName
            }
        })

        return labelName
    }

    componentDidMount() {
        console.log("freedomPay mounted")
        this.setState({
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            address: this.props.checkInAddress,
            phoneNumber: this.props.phone,
            email: this.props.email
        })

        // this.registerClientIP();
    }
    
    componentDidUpdate(prevProps, prevState){
        if(prevState.verifyAttempts != this.state.verifyAttempts){
            console.log("verifyAttempts", this.state.verifyAttempts)
        }
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessageEvent);
    }


    render() {
        const { t } = this.props
        return (

            <div className='freedompay-container-parent'>

                {this.state.IFrameLoading && <div class="loader-ring"></div>}
               
                    <div>
                        <header className="inner-pages w-footer subpages">
                            <a className="button-back" onClick={this.props.backBtn}></a>
                            <div className="heading align-center">
                                <div class="splash-brand">
                                    <img src={`${CMSPath}${this.props.logo}`} />
                                </div>
                                {/* <p className="bold" style={{ color: "inherit" }}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                            </div>
                        </header>
                        <section className="widgets padding-0 margin-0 container-bg">

                            <div class="widget-header widget-header-checkin-inner">
                                {this.props.currentWidgetObj.widgetHeaderImageUrl &&
                                    <div class="widget-header-img">
                                        <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                                    </div>
                                }

                                {
                                    process.env.REACT_APP_NEWER_DESIGN == "true"
                                        ?
                                        <>
                                            <div class="widget-header-title">{t("check_in.verify_card_heading")}</div>
                                            <div class="widget-header-subtitle">{t("check_in.verify_card_subheading")}</div>
                                        </>
                                        :
                                        <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                                }

                            </div>


                            {this.state.shouldShowIFrame ?
                                <>
                                    {this.state.IFrameLoading && <div class="loader-ring"><img src="layout_2/assests/loader.png" /></div>}

                                    <iframe frameborder="0" onLoad={() => {
                                        scrollToTop();
                                        this.setState({ IFrameLoading: false });
                                        $(".freedompay-container").attr("style", "width: 100%; height: 100%")
                                        this.setState({ showLoader: false })
                                    }} style={{ width: 0, height: 0 }} ref={this.iframeRef} className='freedompay-container' src={`https://guest-journey.s3.amazonaws.com/static/FreedomPayHPC.html?sessionKeyFreedomPay=${encodeURIComponent(this.state.sessionKeyFreedomPay)}&isDemo=${DEMO}`}></iframe>

                                    {!this.state.IFrameLoading && <div className="form-controls verify-card">
                                        {/* <button disabled={this.state.disableVerifyButton} className="primary w-100" onClick={this.confirmCardWithFreedomPay}>Verify Card</button> */}
                                    </div>}
                                    {DEMO && <input class="card-skip" onClick={() => this.props.next({ firstName: this.state.firstName, lastName: this.state.lastName })} type="submit" value="Skip" style={{ marginTop: '1rem', color: "#000", backgroundColor: "#fff" }} />}
                                </>
                                :
                            <div className="widgets" style={{ padding: "0 1rem" }}>
                                <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                                    <h2>{t('check_in.booking_details')}</h2>
                                </div>
                                {!(localStorage.getItem('cardVerfied') == 'true') ?
                                    <div className="form-window yet-to-verify">
                                        <div className="form-window-heading">
                                            {t('check_in.card_details')}
                                        </div>
                                        <div className='row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1'>
                                            <p>{CARD_CAN_BE_CHARGED ? t('check_in.enter_card_details') : "Please enter your card details."} </p>
                                            {/* <div className="form-row margin-bottom-1 margin-right-1">
                                                <label htmlFor="name">
                                                    Full Name <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    name="name"
                                                    onChange={this.handleNameChange}
                                                    // value={`${this.state.firstName} ${this.state.lastName}`.trim()}
                                                    value={this.state.fullName || `${this.state.firstName} ${this.state.lastName}`.trim()}
                                                    type="text"
                                                    placeholder="Enter your name"
                                                />
                                                {this.state.nameError && (
                                                    <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                        {this.state.nameError}
                                                    </div>
                                                )}
                                            </div> */}
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="firstName">First Name On Card <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="firstName"
                                                    autoComplete='given-name'
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.firstName}
                                                    type="text"
                                                    placeholder="First Name" />
                                                {this.state.firstNameError && (
                                                    <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                        {this.state.firstNameError}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="lastName">Last Name On Card <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="lastName"
                                                    autoComplete='family-name'
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.lastName}
                                                    type="text"
                                                    placeholder="Last Name" />
                                                {this.state.lastNameError && (
                                                    <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                        {this.state.lastNameError}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="phoneNumber">Phone Number <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="phoneNumber"
                                                    autoComplete='phone'
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.phoneNumber}
                                                    placeholder="Phone Number"
                                                />
                                            </div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="email">Email <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="email"
                                                    autoComplete='email'
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.email}
                                                    placeholder="Email"
                                                    type="email"
                                                />
                                            </div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="address">Address <span style={{ color: "red" }}>*</span></label>
                                                <Select
                                                    className="basic-single"
                                                    value={{ label: this.getAddressLabel() || t('check_in.select_country'), value: this.state.address.country }}
                                                    onChange={(e) => this.handleInputChange(e, "country")}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    name="country"
                                                    options={this.props.countryOptions.map(item => {
                                                        return {
                                                            value: item.countryId,
                                                            label: item.countryName
                                                        }
                                                    })}
                                                />
                                                <input style={{ marginTop: '0.7rem' }} type="text" name="addressLine1" autoComplete='address-line1' value={this.state.address.addressLine1} onChange={(e) => this.handleInputChange(e)} placeholder={t('check_in.street_name_no')} />
                                                <input style={{ marginTop: '0.7rem' }} type="text" name="state" autoComplete='state' value={this.state.address.state} onChange={(e) => this.handleInputChange(e)} placeholder={t('check_in.state_optional')} />
                                                <input style={{ marginTop: '0.7rem' }} type="text" name="city" autoComplete='address-level2' value={this.state.address.city} onChange={(e) => this.handleInputChange(e)} placeholder={t('check_in.city')} />
                                                <input style={{ marginTop: '0.7rem', marginBottom: "1rem" }} name="postalCode" autoComplete='postal-code' value={this.state.address.postalCode} onChange={(e) => this.handleInputChange(e)} placeholder={t('check_in.postal_code')} />
                                            </div>

                                            <div className="form-controls">
                                                <button disabled={this.state.disableVerifyButton} className="primary w-100" onClick={this.confirmCardWithPMS}>Verify Card</button>
                                            </div>
                                            {DEMO && <input class="card-skip" onClick={() => this.props.next({ firstName: this.state.firstName, lastName: this.state.lastName })} type="submit" value="Skip" style={{ marginTop: '1rem', color: "#000", backgroundColor: "#fff" }} />}

                                        </div>
                                    </div>
                                    :
                                    <div class="form-window verified">
                                        <div class="form-window-heading">
                                            Card verified
                                        </div>
                                        <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                            <div class="form-row margin-bottom-1">
                                                <p>Your card was successfully verified.</p>
                                                <p>Tap on NEXT to proceed</p>
                                            </div>
                                            <div class="form-controls">
                                                <button className="primary w-100" onClick={() => this.props.next({ firstName: this.state.firstName, lastName: this.state.lastName })}>{t('check_in.next')}</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            }
                        </section>
                    </div>
                {this.state.showLoader && <Loader close={() => this.setState({ showLoader: false })} displayMsg="Verifying details..." />}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        cardChecksData: state.store2.cardChecksData,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        checkInAddress: state.store2.checkInAddress,
        guestValidationMaxRetry: state.store2.cardChecksData.guestValidationMaxRetry,
    }
}

export default connect(mapStateToProps, {
    setCardStatusPopupProps,
    popupOpenClose,
    sendAnalytics,
    setCheckInAddress,
    setCheckinCurrentPageName
})(withTranslation('translations')(FreedomPay));